import { PlanogramBay } from "./bay";
import { BaseProduct } from "@CommonTypes/merchflow/pog/product";
import type { PlanogramItemUpdateStatus } from "./item";

export interface PlanogramPegboardCommon {
  uniqueId: string;
  yBottom: number;
  height: number;
  holesOffsetHorizontal: number;
  holesOffsetVertical: number;
  holesGapHorizontal: number;
  holesGapVertical: number;
  sectionX?: number;
}

export interface PlanogramPegboardNonCircular extends PlanogramPegboardCommon {
  bay: string;
  placements: PlanogramPegboardPlacementNonCircular[];
}

export class PlanogramPegboard implements PlanogramPegboardCommon {
  uniqueId: string;
  yBottom: number;
  height: number;
  holesOffsetHorizontal: number;
  holesOffsetVertical: number;
  holesGapHorizontal: number;
  holesGapVertical: number;
  placements: PlanogramPegboardPlacement[];
  bay: PlanogramBay;
  sectionX?: number;

  constructor(pegboard: Omit<PlanogramPegboardNonCircular, "bay">, bay: PlanogramBay) {
    this.uniqueId = pegboard.uniqueId;
    this.yBottom = pegboard.yBottom;
    this.height = pegboard.height;
    this.holesOffsetHorizontal = pegboard.holesOffsetHorizontal;
    this.holesOffsetVertical = pegboard.holesOffsetVertical;
    this.holesGapHorizontal = pegboard.holesGapHorizontal;
    this.holesGapVertical = pegboard.holesGapVertical;
    this.sectionX = pegboard.sectionX;
    this.placements = pegboard.placements.map((item) => new PlanogramPegboardPlacement(item, this));
    this.bay = bay;
  }

  addItem(pegboardItem: PlanogramPegboardPlacement) {
    this.placements.push(pegboardItem);
    return pegboardItem;
  }
}

export interface PlanogramPegboardPlacementCommon {
  uniqueId: string;
  holes: {
    holeNoLeft: number;
    holeNoTop: number;
    depth: number;
  }[];
  pegProduct: PegProduct;
}
export type PegProduct = BaseProduct & {
  updateStatus?: PlanogramItemUpdateStatus;
};

export interface PlanogramPegboardPlacementNonCircular extends PlanogramPegboardPlacementCommon {
  pegboard: string;
}

export class PlanogramPegboardPlacement implements PlanogramPegboardPlacementCommon {
  uniqueId: string;
  holes: {
    holeNoLeft: number;
    holeNoTop: number;
    depth: number;
  }[];
  pegboard: PlanogramPegboard;
  pegProduct: PegProduct;

  constructor(
    placement: Omit<PlanogramPegboardPlacementNonCircular, "pegboard">,
    pegboard: PlanogramPegboard,
  ) {
    this.uniqueId = placement.uniqueId;
    this.holes = placement.holes.map((hole) => ({ ...hole }));
    this.pegProduct = placement.pegProduct;
    this.pegboard = pegboard;
  }
}
